<template>
  <div class="relative h-full w-full overflow-hidden">
    <RouterView />
  </div>
</template>

<script setup lang="ts">
import { RouterView } from 'vue-router'
</script>
